import { css } from '@emotion/react';
import { gray5, gray6, gray7, primary, danger, white } from 'styles/global_defaults/colors';
import { semiBoldFontWeight, textSmallFontSize, textXSFontSize } from 'styles/global_defaults/fonts';
import { doubleSpacing, halfSpacing, standardSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';

// TagItem styles
export const tagItemStyles = css`
  align-items: center;
  border: 1px solid ${gray5};
  border-radius: ${standardSpacing}px;
  background-color: ${gray7};
  display: flex;
  font-size: ${textSmallFontSize}px;
  height: 21px;
  margin-right: ${quarterSpacing}px;
  max-width: 250px;
  padding: 0px ${halfSpacing}px;

  .name {
    margin-right: ${halfSpacing}px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .close-btn {
    .icon {
      font-size: ${textXSFontSize}px;
    }
  }
`;

export const overlayStyles = css`
  bottom: -${halfSpacing}px !important;
`;

// TagItemModal styles
export const tagItemModalStyles = css`
  &.tag-item {
    height: ${standardSpacing}px;
    border-radius: ${standardSpacing}px;
    background-color: ${gray7};
    border: 1px solid ${gray5};

    &.inline-item {
      display: inline-flex;
      min-width: 0;
      max-width: 100%;
    }
    &:hover {
      background-color: ${gray6};
    }
  }
`;

// EditTagField styles
export const editTagFieldStyles = css`
  align-items: center;
  border: 1px solid ${primary};
  border-radius: ${standardSpacing}px;
  background-color: ${gray6};
  display: flex;
  font-size: ${textSmallFontSize}px;
  height: 21px;
  margin-right: ${halfSpacing}px;
  padding: 0px ${halfSpacing}px;

  .tag-input {
    background: none;
    border: 0;
    width: 76px;
    &:focus {
      outline: none;
    }
  }

  .close-btn {
    .icon {
      font-size: ${textXSFontSize}px;
    }
  }
`;

export const tagContainerStyles = css`
  background: none;
  min-width: 59px;
  max-width: 220px;
`;

// TagButtonField styles
export const tagButtonFieldStyles = css`
  margin-left: 0px !important;
  &.nv-icon-button {
    &.small-size {
      align-items: center;
      font-weight: ${semiBoldFontWeight};
      display: flex;
      font-size: ${textSmallFontSize}px;
      height: 21px;
      background-color: ${gray6};
      padding: 4px ${halfSpacing}px 3px ${halfSpacing}px;

      .icon-create-new-post {
        &.normal {
          margin-right: ${quarterSpacing}px;
        }
      }
    }
  }
`;

// TagItemAdmin styles
export const tagItemAdminStyles = css`
  &.tag-item {
    height: ${doubleSpacing}px;
    border-radius: ${standardSpacing}px;
    background-color: ${gray7};

    &.inline-item {
      display: inline-flex;
      min-width: 0;
      max-width: 100%;
    }

    &.recently-added {
      animation: highlight 4s ease;
    }

    @keyframes highlight {
      from {background-color: ${gray6};}
      50% {
        background-color: ${gray6};
      }
      to {background-color: ${gray7};}
    }

    .tag-label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover {
      background-color: ${gray6};
    }

    .icon {
      transform: rotate(90deg);
    }

    .icon-item {
      margin-left: ${halfSpacing}px;
    }

    .delete-text {
      color: ${danger};
    }
  }
`;
